export enum SubscriptionPlan {
  AccountantPackageSeatBilly = 'accountant_package_seat_billy',
  AgerasBasic = 'ageras_basic',
  AgerasComplete = 'ageras_complete',
  AgerasFree = 'ageras_free',
  AgerasPlus = 'ageras_plus',
  AgerasStart = 'ageras_start',
  AgerasAccounting = 'agerasAccounting',
  APIPartner = 'apipartner',
  Archive = 'archive',
  Basic = 'basic',
  BasicPaid = 'basic_paid',
  CpaFree = 'cpa_free',
  CpaPlus = 'cpa_plus',
  CpaStart = 'cpa_start',
  Start = 'start',
  Complete = 'complete',
  Business = 'business',
  EBPFree = 'ebp_free',
  CegidEnterpriseFree = 'cegid_enterprise_free',
  Employee = 'employee',
  Free = 'free',
  FriendsofBilly = 'friendofbilly',
  InternalBasicPaid = 'internal_basic_paid',
  InternalCore = 'internal_core',
  InternalCore10PackSeat = 'internal_core_10_pack_seat',
  InternalPlus = 'internal_plus',
  InternalPlusExternal = 'internal_plus_external',
  InternalSmart = 'internal_smart',
  InternalLicense = 'internallicense',
  IToolFree = 'itool_free',
  None = 'none',
  NonProfit = 'nonprofit',
  Plus = 'plus',
  PlusTrial = 'plustrial',
  Premium = 'premium',
  PremiumInternal = 'premium_internal',
  PremiumTest = 'premiumtest',
  PremiumTrial = 'premiumtrial',
  Pro = 'pro',
  ProInternal = 'pro_internal',
  QuadraFree = 'quadra_free',
  SpecialFree = 'specialfree',
}
